// Generated by demos_data.py from the demo videos and their captions. Edit there, not here.
import overview_thumb640 from './demos/overview-thumb640.webp';
import overview_thumb1280 from './demos/overview-thumb1280.webp';
import overview_poster from './demos/overview-poster.webp';
import investigation_plan_thumb640 from './demos/investigation-plan-thumb640.webp';
import investigation_plan_thumb1280 from './demos/investigation-plan-thumb1280.webp';
import investigation_plan_poster from './demos/investigation-plan-poster.webp';
import evidence_thumb640 from './demos/evidence-thumb640.webp';
import evidence_thumb1280 from './demos/evidence-thumb1280.webp';
import evidence_poster from './demos/evidence-poster.webp';
import witnesses_thumb640 from './demos/witnesses-thumb640.webp';
import witnesses_thumb1280 from './demos/witnesses-thumb1280.webp';
import witnesses_poster from './demos/witnesses-poster.webp';
import accused_thumb640 from './demos/accused-thumb640.webp';
import accused_thumb1280 from './demos/accused-thumb1280.webp';
import accused_poster from './demos/accused-poster.webp';
import chargesheet_thumb640 from './demos/chargesheet-thumb640.webp';
import chargesheet_thumb1280 from './demos/chargesheet-thumb1280.webp';
import chargesheet_poster from './demos/chargesheet-poster.webp';

// Videos stream from Cloudflare R2. Override for local testing with REACT_APP_MEDIA_BASE.
export const MEDIA_BASE = process.env.REACT_APP_MEDIA_BASE || 'https://media.legalapp.in/demo/';

export const DEMOS = [
  {
    id: "overview",
    kicker: "Overview",
    title: "LegalApp in 60 seconds",
    desc: "A one-minute tour, from the first complaint to the chargesheet.",
    file: "LegalApp_reel.mp4",
    dur: "1:00",
    thumb: overview_thumb640,
    thumb2x: overview_thumb1280,
    poster: overview_poster,
    chapters: [],
  },
  {
    id: "investigation-plan",
    kicker: "Demo 1 of 5",
    title: "Generate an Investigation Plan",
    desc: "Upload an FIR and get a prioritized investigation plan, built from the SOPs for the offence.",
    file: "LegalApp_Investigation_Plan_Demo.mp4",
    dur: "4:02",
    thumb: investigation_plan_thumb640,
    thumb2x: investigation_plan_thumb1280,
    poster: investigation_plan_poster,
    chapters: [{ t: 0, time: "0:00", label: "Introduction" }, { t: 25, time: "0:25", label: "Step 1 · Upload the FIR" }, { t: 113, time: "1:53", label: "Step 2 · Generate the investigation plan" }, { t: 224, time: "3:44", label: "Recap" }],
  },
  {
    id: "evidence",
    kicker: "Demo 2 of 5",
    title: "Identify Evidence",
    desc: "Find the evidence the case needs, including what the FIR doesn't mention, ranked by priority.",
    file: "LegalApp_Evidence_Demo.mp4",
    dur: "3:20",
    thumb: evidence_thumb640,
    thumb2x: evidence_thumb1280,
    poster: evidence_poster,
    chapters: [{ t: 0, time: "0:00", label: "Introduction" }, { t: 32, time: "0:32", label: "Step 1 · Open the case" }, { t: 43, time: "0:43", label: "Step 2 · Identify the evidence" }, { t: 182, time: "3:02", label: "Recap" }],
  },
  {
    id: "witnesses",
    kicker: "Demo 3 of 5",
    title: "Find Witnesses & Questions",
    desc: "See who to question, including people the FIR doesn't name, and the questions to ask each one.",
    file: "LegalApp_Witnesses_Demo.mp4",
    dur: "4:26",
    thumb: witnesses_thumb640,
    thumb2x: witnesses_thumb1280,
    poster: witnesses_poster,
    chapters: [{ t: 0, time: "0:00", label: "Introduction" }, { t: 35, time: "0:35", label: "Step 1 · Open the case" }, { t: 46, time: "0:46", label: "Step 2 · Identify the witnesses" }, { t: 160, time: "2:40", label: "Step 3 · Get the questions" }, { t: 247, time: "4:07", label: "Recap" }],
  },
  {
    id: "accused",
    kicker: "Demo 4 of 5",
    title: "Interrogate the Accused",
    desc: "Get prioritized interrogation questions for every accused: role, money trail and intent.",
    file: "LegalApp_Accused_Interrogation_Demo.mp4",
    dur: "3:53",
    thumb: accused_thumb640,
    thumb2x: accused_thumb1280,
    poster: accused_poster,
    chapters: [{ t: 0, time: "0:00", label: "Introduction" }, { t: 39, time: "0:39", label: "Step 1 · Open the case" }, { t: 48, time: "0:48", label: "Step 2 · Prepare the questions" }, { t: 79, time: "1:19", label: "Step 3 · Review the questions" }, { t: 213, time: "3:33", label: "Recap" }],
  },
  {
    id: "chargesheet",
    kicker: "Demo 5 of 5",
    title: "Draft the Chargesheet",
    desc: "Upload the case diary and get a draft chargesheet: the case facts, every investigation step in date order, and the conclusion.",
    file: "LegalApp_Charge_Sheet_Demo.mp4",
    dur: "3:44",
    thumb: chargesheet_thumb640,
    thumb2x: chargesheet_thumb1280,
    poster: chargesheet_poster,
    chapters: [{ t: 0, time: "0:00", label: "Introduction" }, { t: 41, time: "0:41", label: "Step 1 · Open the case" }, { t: 57, time: "0:57", label: "Step 2 · Upload the case diary" }, { t: 87, time: "1:27", label: "Step 3 · Get the chargesheet" }, { t: 205, time: "3:25", label: "Recap" }],
  },
];
